import { buildVueDompurifyHTMLDirective } from 'vue-dompurify-html'

import domPurifyConfig from '@app/shared/config/dom-purify'
import { keepXhrModalOnclick } from '@app/utils/sanitize-xhr-modal-html'

// The directive builds its own DOMPurify instance, so this hook does not
// reach the global `v-dompurify-html` directive.
const xhrModalHtmlDirective = buildVueDompurifyHTMLDirective({
  default: domPurifyConfig,
  hooks: { uponSanitizeAttribute: keepXhrModalOnclick },
})

export default xhrModalHtmlDirective
